import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { IsMonoBrand } from '../../../guards/is-mono-brand-guard/is-mono-brand.guard';
import { LegacyTabComponent } from './components/legacy-tab-component/legacy-tab.component';
import { NewTabComponent } from './components/new-tab-component/new-tab.component';
import { TabPage } from './tab.page';

const routes: Routes = [
	{
		path: '',
		component: TabPage,
		children: [
			{
				path: 'brand-list',
				children: [
					{
						path: '',
						canActivate: [IsMonoBrand],
						loadChildren: '../brand-list/brand-list.module#BrandListModule',
					},
					{
						path: 'poap-nft-list',
						loadChildren:
							'../poap-nft-list/poap-nft-list.module#PoapNftListPageModule',
					},
					{
						path: 'poap-detail/:tokenId',
						loadChildren:
							'../poap-detail/poap-detail.module#PoapDetailPageModule',
					},
					{
						path: 'poap-detail/qr-hash/:qrHash',
						loadChildren:
							'../poap-detail/poap-detail.module#PoapDetailPageModule',
					},
					{
						path: 'brand-product-list/:brandId',
						loadChildren:
							'../brand-product-list/brand-product-list.module#BrandProductListModule',
					},
					// Leave this before product-detail/:network/.*/ or it will be overriden
					{
						path: 'product-detail/notification/:network/:certificateId',
						loadChildren: '../chat/chat.module#ChatPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId/:passphrase/:method',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
					{
						path: 'brand-page/:brandId',
						loadChildren: '../brand-page/brand-page.module#BrandPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId/myCertificate',
						loadChildren:
							'../certificate-card/certificate-card.module#CertificateCardModule',
					},
					{
						path: 'pending/:network/:pendingCertificateIdOrUrl',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
				],
			},
			{
				path: 'scan-full-page',
				children: [
					{
						path: '',
						loadChildren: '../scan-v2/scan-v2.module#ScanV2PageModule',
					},
					{
						path: 'product-detail/:network/:certificateId',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId/:passphrase/:method',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
				],
			},
			{
				path: 'scan',
				children: [
					{
						path: '',
						loadChildren: '../scan/scan.module#ScanPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId/:passphrase/:method',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
				],
			},
			{
				path: 'exchange',
				children: [
					{
						path: '',
						loadChildren: '../exchange/exchange.module#ExchangePageModule',
					},
				],
			},
			{
				path: 'scan-edgyn',
				children: [
					{
						path: '',
						loadChildren: '../scan-edgyn/scan-edgyn.module#ScanEdgynPageModule',
					},
					{
						path: 'product-detail/:network/:certificateId',
						loadChildren:
							'../product-detail/product-detail.module#ProductDetailPageModule',
					},
				],
			},
			{
				path: 'brands',
				children: [
					{
						path: '',
						loadChildren:
							'../arianee-brands-list/arianee-brands-list.module#ArianeeBrandsListModule',
					},
				],
			},
			{
				path: 'noti',
				loadChildren: '../noti/noti.module#NotiPageModule',
			},
			{
				path: 'setting',
				loadChildren: '../setting/setting.module#SettingPageModule',
			},
			{
				path: '',
				redirectTo: 'brand-list',
			},
		],
	},
	{
		path: '',
		redirectTo: 'product',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		TranslateModule,
		RouterModule.forChild(routes),
	],
	declarations: [TabPage, LegacyTabComponent, NewTabComponent],
})
export class TabPageModule {}
